var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fw-title',{attrs:{"titles":"订单备注"}}),_c('el-row',{staticStyle:{"margin-left":"30px"}},[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v(_vm._s(_vm.detailsData.desc))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }